import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = () => ({
  related_options: [],
  account_cms_groups: [],
});

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
